export default function defaultReducer(key, initialState) {
  return (state = initialState, action) => {
    switch (action.type) {
      case key:
        return Array.isArray(state)
          ? action.payload
          : typeof state === "object"
            ? { ...state, ...action.payload }
            : action.payload;
      default:
        return state;
    }
  };
}
